import { TableCell, TableHead, TableRow } from '@mui/material'

import type { BidDetailColumnGroup, BidDetailDataColumn } from './types'

export type BidDetailTableHeadRowProps = Readonly<{
  /** Top header row — column groups spanning multiple data columns. */
  columnGroups: ReadonlyArray<BidDetailColumnGroup>
  /** Bottom header row — one entry per data column. */
  dataColumns: ReadonlyArray<BidDetailDataColumn>
}>

export default function BidDetailTableHeadRow({ columnGroups, dataColumns }: BidDetailTableHeadRowProps) {
  return (
    <TableHead>
      <TableRow>
        {columnGroups.map((group, index) => {
          return (
            <TableCell
              // eslint-disable-next-line react/no-array-index-key
              key={`group-${index}`}
              align="center"
              colSpan={group.span}
              sx={{
                backgroundColor: 'background.paper',
                borderLeft: index > 0 ? 1 : 0,
                borderLeftColor: 'divider',
                fontWeight: 600,
              }}
            >
              {group.label}
            </TableCell>
          )
        })}
      </TableRow>
      <TableRow>
        {dataColumns.map((column, index) => {
          return (
            <TableCell
              // eslint-disable-next-line react/no-array-index-key
              key={`col-${index}`}
              align={column.align ?? 'right'}
              rowSpan={column.span}
              sx={{
                backgroundColor: 'background.paper',
                verticalAlign: column.valign,
                width: column.width,
                minWidth: column.minWidth,
                borderRight: 1,
                borderRightColor: 'divider',
                color: 'text.secondary',
                fontWeight: 500,
              }}
            >
              {column.label}
            </TableCell>
          )
        })}
      </TableRow>
    </TableHead>
  )
}
